export enum CouponType {
    AMOUNT = 0,
    PERCENT = 1,
}

export interface IDjangoCoupon {
    id: number;
    code: string;
    code_name: string;
    description: string;
    family: number | null;
    family_name: string;
    foundry: number | null;
    foundry_name: null;
    discount: number;
    expiration_date: string; // YYYY-MM-DD formatted date string
    discount_type: CouponType;
    expired: boolean;
}
